import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home/Index.vue';
import Terminal from './views/Terminal/Index.vue';
import TerminalH5 from './views/Terminal/H5.vue';
import TerminalMini from './views/Terminal/Mini.vue';
import TerminalPc from './views/Terminal/Pc.vue';
import TerminalApp from './views/Terminal/App.vue';
import SceneScience from './views/Scene/Science.vue';
import SceneTeach from './views/Scene/Teach.vue';
import SceneCompany from './views/Scene/Company.vue';
import ScenePrice from './views/Scene/Price.vue';
import AbilityBusiness from './views/Ability/Business.vue';
import AbilityBrand from './views/Ability/Brand.vue';
import AbilityUser from './views/Ability/User.vue';
import ServiceWelfare from './views/ServicePages/Welfare.vue';
import Channel from './views/Channel/Index.vue';
import Live from './views/Live/Index.vue';
import LiveOverview from './views/Live/Overview.vue';
import LiveSLive from './views/Live/SLive.vue';
import LiveSClass from './views/Live/SClass.vue';
import Case from './views/Case/Index.vue';
import Introduce from './views/Introduce/Index.vue';
import Join from './views/Join/index.vue';
import About from './views/About/index.vue';
import News from './views/News/index.vue';
import NewsDetail from './views/News/detail.vue';
import Price from './views/Price/index.vue';
import Download from './views/Download/Index.vue';
import DownloadOverview from './views/Download/Overview.vue';
import DownloadDown from './views/Download/Down.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  }, {
    path: '/terminal',
    name: 'terminal',
    component: Terminal,
    children: [{
      path: '/',
      name: 'terminalH5',
      component: TerminalH5
    }, {
      path: 'mini',
      name: 'terminalMini',
      component: TerminalMini
    }, {
      path: 'pc',
      name: 'terminalPc',
      component: TerminalPc
    }, {
      path: 'app',
      name: 'terminalApp',
      component: TerminalApp
    }]
  }, {
    path: '/scene/science',
    name: 'sceneScience',
    component: SceneScience
  }, {
    path: '/scene/teach',
    name: 'sceneTeach',
    component: SceneTeach
  }, {
    path: '/scene/company',
    name: 'sceneCompany',
    component: SceneCompany
  }, {
    path: '/scene/price',
    name: 'scenePrice',
    component: ScenePrice
  }, {
    path: '/ability/business',
    name: 'abilityBusiness',
    component: AbilityBusiness
  }, {
    path: '/ability/brand',
    name: 'abilityBrand',
    component: AbilityBrand
  }, {
    path: '/ability/user',
    name: 'abilityUser',
    component: AbilityUser
  }, {
    path: '/serviceWelfare',
    name: 'serviceWelfare',
    component: ServiceWelfare
  }, {
    path: '/channel',
    name: 'channel',
    component: Channel
  }, {
    path: '/live',
    name: 'live',
    component: Live,
    children: [{
      path: 'overview',
      name: 'liveOverview',
      component: LiveOverview
    }, {
      path: 'sLive',
      name: 'liveSLive',
      component: LiveSLive
    }, {
      path: 'sClass',
      name: 'liveSClass',
      component: LiveSClass
    }]
  }, {
    path: '/download',
    name: 'download',
    component: Download,
    children: [{
      path: '/',
      name: 'downloadOverview',
      component: DownloadOverview
    }, {
      path: 'down',
      name: 'downloadDown',
      component: DownloadDown
    }]
  }, {
    path: '/case',
    name: 'case',
    component: Case
  }, {
    path: '/introduce',
    name: 'introduce',
    component: Introduce
  }, {
    path: '/join',
    name: 'join',
    component: Join
  }, {
    path: '/about',
    name: 'about',
    component: About
  }, {
    path: '/news',
    name: 'news',
    component: News
  }, {
    path: '/newsDetail',
    name: 'newsDetail',
    component: NewsDetail
  }, {
    path: '/price',
    name: 'price',
    component: Price
  }]
});
